import { ConstantsService } from 'src/app/services/constants.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HitoService {
  public url = ConstantsService.HITOS_URL;
  private urlArchivos = ConstantsService.HITOS_FILE_URL;

  constructor(private http:HttpClient) { }

 
statusChange(data:any): Observable<any>{
  let editaEstadoHito={
    ...data,
    estado:"2"
  } 
  return this.http.patch(`${this.url}${data.idSprHito}`,editaEstadoHito ) 
}


download(name:string): Observable<any>{
  return this.http.get(`${this.urlArchivos}/`+ name)
}

postArchivo(formData:any, id:number): Observable<any>{
  return this.http.post(`${this.urlArchivos}/`+ id, formData).pipe(map(data => {
    return data;
  }));
}

  create(formData:any): Observable<any>{
    return this.http.post(`${this.url}`, formData).pipe(map(data => {
      return data;
    }));
}
list(query = ''): Observable<any>{
  return this.http.get(`${this.url}${query}`).pipe(map(data => {
    return data;
   }));
}
update(formData:any): Observable<any>{
  let {idSprHito} = formData;
  return this.http.patch(`${this.url}${idSprHito}`,formData).pipe(map(
    data => {
      return data;
    }
  ));;
}
delete(dataDelete:any): Observable<any>{
  return this.http.patch(`${this.url}${dataDelete.idSprHito}`,dataDelete).pipe(map(data => {
    return data;
  }));
}

}

